import {
  AdyenStoreType,
  CacheStatusType,
  ConfigType,
  PaymentHealthType,
  RoomType,
  TableType
} from 'shared/store/types'
import { instance } from './instance'
import { GetPathes } from './types'
import { getAppName } from 'shared/helpers/getAppName'

export class GET {
  public static async config(branchId: number): Promise<ConfigType> {
    const res: ConfigType = await instance.get(`${GetPathes.GET_CONFIG}?branchId=${branchId}`)
    return res
  }

  public static async adyenStores(): Promise<AdyenStoreType[]> {
    const res: { stores: AdyenStoreType[] } = await instance.get(`${GetPathes.GET_ADYEN_STORES}`)
    return res?.stores || []
  }

  public static async paymentStatus(branchId: number): Promise<PaymentHealthType> {
    const res = await instance.get(`${GetPathes.CHECK_PAYMENT}?branchId=${branchId}`)
    return res
  }

  public static async branches(isQRM: boolean): Promise<any[]> {
    const res: any[] = await instance.get(`${GetPathes.GET_BRANCHES}?appName=${getAppName(!isQRM)}`)
    return res
  }

  public static async captions(): Promise<{ rooms: RoomType[]; tables: TableType[] }> {
    const res: { rooms: RoomType[]; tables: TableType[] } = await instance.get(
      `${GetPathes.GET_CAPTIONS}`
    )
    return res
  }

  public static async userList(): Promise<any> {
    const res = await instance.get(`${GetPathes.GET_USERS}`)
    return res
  }

  public static async cacheStatus(registerId?: number): Promise<CacheStatusType> {
    const qs = typeof registerId === 'number' ? `?registerId=${registerId}` : ''
    const res: CacheStatusType = await instance.get(`${GetPathes.GET_CACHE_STATUS}${qs}`)
    return res
  }
}
